// Custom JS - stickyHeader.js

const StickyHeader = {
  header: null,
  adminBar: null,
  headerHeight: 0,
  adminBarHeight: 0,
  isSticky: false,

  // Inizializza l'header sticky con ID dinamico e opzionale adminBar
  initialize(headerId, adminBarId = null) {
    this.header = document.getElementById(headerId);
    this.adminBar = adminBarId ? document.getElementById(adminBarId) : null;

    if (!this.header) {
      console.warn(`Header con ID "${headerId}" non trovato.`);
      return;
    }

    // Calcola l'altezza di header e admin bar
    this.headerHeight = this.header.offsetHeight;
    this.adminBarHeight = this.adminBar ? this.adminBar.offsetHeight : 0;

    this.attachScrollListener();
    this.attachResizeListener();
  },

  // Aggiorna il padding-top del body SOLO quando l'header diventa sticky
  updateBodyPadding(applyPadding) {
    const totalPadding = applyPadding ? this.headerHeight : 0;
    document.body.style.paddingTop = `${totalPadding}px`;
  },

  // Imposta la posizione top dell'header in base all'admin bar
  adjustHeaderPosition(applyOffset) {
    const offset = applyOffset ? this.adminBarHeight : 0;
    this.header.style.top = `${offset}px`;
  },

  // Aggiunge o rimuove la classe sticky in base allo scroll
  handleScroll() {
    const currentScrollPosition = window.scrollY;

    if (currentScrollPosition > 0 && !this.isSticky) {
      this.header.classList.add("sticky-header");
      this.adjustHeaderPosition(true); // Applica offset per admin bar
      this.updateBodyPadding(true); // Applica padding quando sticky
      this.isSticky = true;
    } else if (currentScrollPosition === 0 && this.isSticky) {
      this.header.classList.remove("sticky-header");
      this.adjustHeaderPosition(false); // Rimuove offset
      this.updateBodyPadding(false); // Rimuove il padding
      this.isSticky = false;
    }
  },

  // Listener per lo scroll
  attachScrollListener() {
    window.addEventListener("scroll", () => this.handleScroll());
  },

  // Listener per il resize (aggiorna l'altezza dell'header e admin bar)
  attachResizeListener() {
    window.addEventListener("resize", () => {
      this.headerHeight = this.header.offsetHeight;
      this.adminBarHeight = this.adminBar ? this.adminBar.offsetHeight : 0;
      if (this.isSticky) {
        this.updateBodyPadding(true);
        this.adjustHeaderPosition(true);
      }
    });
  },
};

export default StickyHeader;
